module.exports = __webpack_public_path__ + "img/48_19.bfda2144.png";